import * as CryptoJS from "crypto-js";

/**
 * 🐱‍🏍 Starts the Tawk.to messenger service
 * @param user - the current user
 */
export function startMessenger(user: any) {
  try {
    if (user) {
      let hmac = CryptoJS.algo.HMAC.create(
        CryptoJS.algo.SHA256,
        "eafd0b5424125d80139891a5938ef525ad1c6ae6"
      );
      hmac.update(user.email);

      let properties = {
        name: user.name != "Anonymous" ? user.name : "",
        email: user.email,
        hash: CryptoJS.enc.Hex.stringify(hmac.finalize()),
      };

      (window as any).Tawk_API.setAttributes(properties, (error) => {});
    }
    (window as any).Tawk_API.showWidget();
  } catch (e) {}
}

/**
 * 🤚 Shutdowns the Tawk.to messenger service
 */
export function shutdownMessenger() {
  let messenger = (window as any).Tawk_API;
  messenger.minimize();
  messenger.hideWidget();
}
